<template>
	
  <div class="p-grid nested-grid details-info">
    <div class="p-col-12 p-sm-6">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 editable-field">
          <label for="name">{{$t('details.info_name')}}</label>
          <div v-if="!editing.name" class="text">{{appliance.name ?? $functions.fixModelName(appliance.modelNumber)}}</div>
          <div v-else>
            <InputText id="add_dialog_code" type="text" v-model="data.name" 
              :placeholder="$t('details.info_name_ph')"
              :class="{'p-invalid': !data.name && submitted}"
              />
          </div>
          <div v-if="role==='USER' || role.includes('SERVICE')" class="editing-buttons">
            <img v-if="!editing.name" src="assets/irinox/icons/info_edit.svg" @click="()=>editing.name=true" :alt="$t('common.edit')"/>
            <div v-else class="p-d-flex p-jc-center p-ai-center">
              <img src="assets/irinox/icons/info_save.svg" @click="saveName" :alt="$t('common.save')"/>
              <img src="assets/irinox/icons/close.svg" @click="()=>editing.name=false" width="20" :alt="$t('common.cancel')"/>
            </div>
          </div>
        </div>
        <Divider />
        <div class="p-field p-col-12">
          <label for="model">{{$t('details.info_model')}}</label>
          <div>{{$functions.fixModelName(appliance.modelNumber)}}</div>
        </div>
        <!-- <Divider v-if="appliance.type=='ABBATTITORE' || appliance.type=='FERMALIEVITA'"/>
        <div v-if="appliance.type=='ABBATTITORE' || appliance.type=='FERMALIEVITA'" class="p-field p-col-12">
          <label for="port">{{$t('details.info_port')}}</label>
          <div>{{infoDoorAlarm}}</div>
        </div> -->
        <Divider />
        <div class="p-field p-col-12">
          <label for="version">{{$t('details.info_version')}}</label>
          <div>{{infoSoftwareVersion}}</div>
        </div>
        <Divider />
        <div class="p-field p-col-12">
          <label for="version">{{$t('details.info_company')}}</label>
          <div>{{appliance.companyName ?? '-'}}</div>
        </div>
      </div>
    </div>
    <Divider layout="vertical" />
    <div class="p-col-12 p-sm-6">
      <div class="p-fluid p-formgrid p-grid">
        <div v-if="role==='USER'" class="p-field p-col-12 editable-field">
          <label for="lab">{{$t('details.info_lab')}}</label>
          <div v-if="!editing.lab" class="text">{{appliance.labName ?? '-'}}</div>
          <div v-else>
            <Dropdown id="lab" v-model="data.labId" :options="labs" optionLabel="name" optionValue="id" 
              :placeholder="$t('details.info_lab_ph')" @change="changeLab" 
              :class="{'p-invalid':!data.labId && submitted}"/>
          </div>
          <div class="editing-buttons">
            <img v-if="!editing.lab" src="assets/irinox/icons/info_edit.svg" @click="()=>editing.lab=true" :alt="$t('common.edit')"/>
            <div v-else class="p-d-flex p-jc-center p-ai-center">
              <img src="assets/irinox/icons/info_save.svg" @click="saveLab" :alt="$t('common.save')"/>
              <img src="assets/irinox/icons/close.svg" @click="()=>editing.lab=false" width="20" :alt="$t('common.cancel')"/>
            </div>
          </div>
        </div>
        <Divider v-if="role==='USER'"/>
        <div class="p-field p-col-12">
          <label for="model">{{$t('details.info_serialNumber')}}</label>
          <div>{{appliance.serialNumber}}</div>
        </div>
        <!-- <Divider v-if="appliance.type=='ABBATTITORE' || appliance.type=='FERMALIEVITA'"/>
        <div v-if="appliance.type=='ABBATTITORE' || appliance.type=='FERMALIEVITA'" class="p-field p-col-12 editable-field">
          <label for="sanigen">{{$t('details.info_sanigen')}}</label>
          <div v-if="!editing.sanigenLevel" class="text">{{infoSanigenLevel}}</div>
          <div v-else>
            <Dropdown id="lab" v-model="data.sanigenLevel" :options="sanigenLevels" optionLabel="name" optionValue="code" 
              :placeholder="$t('details.info_sanigen_ph')"
              :class="{'p-invalid':data.sanigenLevel==null && submitted}"/>
          </div>
          <div v-if="canSanigenBeEdited && !role.includes('INTERNAL')" class="editing-buttons">
            <img v-if="!editing.sanigenLevel" src="assets/irinox/icons/info_edit.svg" @click="()=>editing.sanigenLevel=true"/>
            <div v-else class="p-d-flex p-jc-center p-ai-center">
              <img src="assets/irinox/icons/info_save.svg" @click="saveSanigen"/>
              <img src="assets/irinox/icons/close.svg" @click="()=>editing.sanigenLevel=false" width="20"/>
            </div>
          </div>
        </div> -->
        <Divider />
        <div class="p-field p-col-12 p-d-flex p-jc-evenly">
          <Button v-if="$config.currentEnv=='dev'" :label="$t('details.passport_button')" icon="irinox-icon-button icon-passport" iconPos="left" class="p-mr-1 button-passport" @click="openPassport"/>
          <Button v-if="role=='USER' || role.includes('SERVICE')" :label="$t('details.delete_button')" icon="irinox-icon-button icon-delete" iconPos="left" @click="deleteDialog" class="p-button-outlined p-button-danger p-ml-1" />
        </div>
      </div>
    </div>
  </div>

  <!--                    -->
  <!-- ERRORS and SUCCESS -->
  <!--                    -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.delete_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.blockingError" 
    mode="error" 
    :message="$t('details.delete_error')"
    :life="0" 
    @update:visible="dialog.blockingError = $event" />
  <IrinoxDialogDark :visible="dialog.deleteSuccess" 
    mode="success" 
    :message="$t('details.delete_success')"
    :life="3000" 
    @update:visible="dialog.deleteSuccess = $event" />
  <IrinoxDialogDark :visible="dialog.addLabSuccess" 
    mode="success" 
    :message="$t('laboratories.success_dialog')"
    :life="3000" 
    @update:visible="dialog.addLabSuccess = $event" />

  <!--                -->
  <!-- DEFROST DIALOG -->
  <!--                -->
  <IrinoxDialogDark :visible="dialog.delete" 
    mode="confirm" 
    :leftB="$t('details.delete_dialog_cancel_button')" 
    @click:left-button="()=>{dialog.delete=!dialog.delete}" 
    :rightB="$t('details.delete_dialog_ok_button')" 
    @click:right-button="deleteAppliance" 
    :message="$t('details.delete_dialog')"
    icon="assets/irinox/icons/delete_big.svg" />

  <IrinoxDialogLight :visible="dialog.addLab" 
    mode="lab"
    @update:visible="dialog.addLab = $event" 
    @click:button="addLab" />

</template>

<script>
import { mapGetters } from 'vuex';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import IrinoxDialogLight from '../IrinoxDialogLight.vue';
import ApplianceService from '../../service/ApplianceService';
import EventHubListenerService from '../../service/EventHubListenerService';

export default {
    components: {
      IrinoxDialogDark,
      IrinoxDialogLight
    },
    props: {
      serialNumber: String
    },
    data() {
        return {
          dialog: {
            delete: false,
            error: false,
            blockingError: false,
            deleteSuccess: false,
            addLab: false,
            addLabSuccess: false,
          },
          editing: {
            name: false,
            lab: false,
            sanigenLevel: false
          },
          submitted: false,
          data: {
            name: null,
            labId: null,
            sanigenLevel: null
          },
          labs: [],
          lab: {},
          sanigenLevels: []
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          deviceTwin: 'appliances/deviceTwin',
          role: 'userdata/role',
        }),
        appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        },
        infoSanigenLevel: function() {
          return this.deviceTwin && this.deviceTwin.status && this.appliance && this.appliance.gamma ? this.$t('details.'+this.getGammaLabel(this.appliance.gamma)+'.sanigen_level_'+this.deviceTwin.status.sanigenLevel) : "-";
        },
        infoSoftwareVersion: function() {
          return this.deviceTwin && this.deviceTwin.versions ? this.deviceTwin.versions.softwareVersion : "-";
        },
        infoDoorAlarm: function() {
          return this.appliance && this.appliance.status && this.appliance.status.door!=null ? this.$t('details.mf.door_active_'+this.appliance.status.door) : "-";
        },
        canSanigenBeEdited: function() {
          return this.appliance && this.appliance.online==true;
            // && (
            //   this.appliance.gamma!=='MYA' 
            //   || (this.deviceTwin && this.deviceTwin.status && this.deviceTwin.status.sanigenLevel>=0 && this.deviceTwin.status.sanigenLevel<60000)
            // );
        }
    },
    watch: {
      'data.labId': 'changeLab'
    },
    created() {
      this.applianceService = new ApplianceService();
      this.eventHubListenerService = new EventHubListenerService();
      this.data.name = this.appliance.name;

      let start = 0;
      let end = 5;
      if(this.appliance.gamma==='MYA') {
        start = -1;
        end = 4;
      }
      if(this.appliance.type=='ABBATTITORE' || this.appliance.type=='FERMALIEVITA') {
        for(let i=start; i<=end; i++) {
          this.sanigenLevels.push({
              code: this.getSanigenLevel(i),
              name: this.$t("details."+this.getGammaLabel(this.appliance.gamma)+"['sanigen_level_"+this.getSanigenLevel(i)+"']")
            });
        }
      }
    },
    mounted() {
      if(this.role==='USER') {
        this.getLabs();
      }
    },
    methods: {
      getGammaLabel(gamma) {
        return gamma.split(" ")[0].toLowerCase();
      },
      getSanigenLevel(i) {
        if(i<0) {
          return 65536+i;
        }
        return i;
      },
      deleteDialog() {
        this.dialog.delete = true;
      },
      deleteAppliance() {
        this.dialog.delete = false;
        this.applianceService.deleteAppliance(this.personaltoken, this.serialNumber)
          .then((data) => {
            if(data.code=="200") {
              this.dialog.deleteSuccess = true;
              setTimeout(function() {
                this.$router.push({ name: 'dashboard' });
              }.bind(this),3000);
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      saveName() {
        this.submitted = true;
        if(!this.data.name) {
          return;
        }
        let updateData = {
          name: this.data.name
        }
        this.applianceService.putAppliance(this.personaltoken, this.serialNumber, updateData)
          .then((data) => {
            this.submitted = false;
            this.editing.name = false;
            if(data.code=="200") {
              this.$router.go();
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
            this.submitted = false;
            this.editing.name = false;
          });
      },
      getLabs() {
        this.applianceService.getLabs(this.personaltoken)
          .then(labs => {
            this.populateLabs(labs);
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.blockingError = true;
          });
      },
      populateLabs(labs) {
        this.labs = labs;
        this.labs.sort((a,b) => this.$functions.compareStrings(a, b, "name"));
        this.labs.push({ id: -1, name: this.$t('laboratories.laboratory_add') });
      },
      changeLab() {
        if(this.data.labId!=null) {
          if(this.data.labId==-1) {
            this.data.labId = 0;
            this.lab = {};
            this.dialog.addLab = true;
          } else {
            for (let i = 0; i < this.labs.length; i++) {
              if(this.labs[i].id == this.data.labId) {
                this.lab = this.labs[i];
              }
            }
          }
        } else {
          this.lab = {};
        }
      },
      addLab(labName) {
        let updateData = {};
        updateData.name = labName;

        this.applianceService.postLabs(this.personaltoken, updateData)
          .then(labs => {
            this.dialog.addLab = false;
            this.dialog.addLabSuccess = true;
            this.populateLabs(labs);
          })
          .catch(error => {
            this.dialog.addLab = false;
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });

      },
      saveLab() {
        this.submitted = true;
        if(!this.data.labId) {
          return;
        }
        let updateData = {
          lab: this.data.labId
        }
        this.applianceService.putAppliance(this.personaltoken, this.serialNumber, updateData)
          .then((data) => {
            this.submitted = false;
            this.editing.lab = false;
            if(data.code=="200") {
              this.$router.go();
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
            this.submitted = false;
            this.editing.lab = false;
          });
      },
      saveSanigen() {
        this.submitted = true;
        if(this.data.sanigenLevel == null) {
          return;
        }
        let updateData = {
          sanigenLevel: this.data.sanigenLevel
        }
        this.eventHubListenerService.postSetParameter(this.personaltoken, this.serialNumber, updateData)
          .then((data) => {
            this.submitted = false;
            this.editing.sanigenLevel = false;
            if(data.code=="200") {
              let dt = this.$functions.clone(this.deviceTwin);
              dt.status.sanigenLevel = this.data.sanigenLevel;
              this.$store.commit('appliances/deviceTwin', dt);
              // this.$router.go();
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
            this.submitted = false;
            this.editing.sanigenLevel = false;
          });
      },
      openPassport() {
        this.applianceService.getPassportUrl(this.personaltoken, this.serialNumber)
        .then((data) => {
            if(data.code=="200") {
              window.open(data.body, '_blank');
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
            // window.open('https://app.madeinblock.it/pp/uid/urn:irnx:dpp:e:IT02152370264:s:240300099M?pp_role=oem&ez-uid=195&ez-exp=1744639013&ez-sign=431fc27fcc01392325c0a5fc14f0052731c263a4292a6c7d98ef80dfff45a75c', '_blank');
          });
      }
    }
}
</script>

<style scoped>

.p-fluid .p-inputtext {
  width: 70%;
}
.p-fluid .p-dropdown {
  width: 70%;
}

</style>